module.exports = __webpack_public_path__ + "static/media/home_page.2aff55f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_page.jpg
// module id = 640
// module chunks = 2